import { useForm } from 'react-hook-form';

import {
  Button,
  Input,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Text,
  Box,
  Divider,
  Link,
  HStack,
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { Link as RLink } from 'react-router-dom';

import Container from '../components/Container';
import { removeErrorParam } from '../helpers';
import { getInfo, useIdp } from '../services';
import PasswordPolicy from '../components/PasswordPolicy';

const SignupPage = () => {
  const search = new URLSearchParams(window.location.search);
  const [error, setError] = useState(search.has('error'));
  const [errorMsg, setErrorMsg] = useState('We couldn\'t create your account, please contact support or try again');
  const ref = useRef();
  const { passwordPolicy } = useIdp() || {};

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting, isValid },
    control,
    setValue,
  } = useForm({ mode: 'onChange' });

  const onSubmit = async (data) => {
    setError(false);
    const asd = window.AmazonCognitoAdvancedSecurityData.getData(data.user, '', search.get('client_id'));
    ref.current.asd.value = asd;
    ref.current.submit();
    return true;
  };

  const onHandleSubmit = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    handleSubmit(onSubmit)();
  };

  useEffect(() => {
    const [rta, abortController] = getInfo('signup');

    rta.then((data = []) => {
      const f = data.find((d) => d.targetRequestPath === '/signup');
      if (f) {
        if (f.status === 'error') {
          window.location.replace(`/error${window.location.search}`);
        } else if (f.map?.errorMessage || f.map?.bindingResultErrors) {
          setErrorMsg(f.map.errorMessage || f.map.bindingResultErrors);
          setError(true);
        }
      }
    });
    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <Container py="8">
      {/* eslint-disable-next-line max-len */}
      <form ref={ref} onSubmit={onHandleSubmit} action={`${process.env.REACT_APP_BACKEND}/auth/signUp${window.location.search}`} method="POST">
        <Heading className="card-title text-center" mb="2" size="md" fontWeight="normal">
          Sign up with a new account
        </Heading>
        <Text fontSize="sm" color="gray.600">Create an account for free</Text>
        {error && (
          <>
            {errorMsg.split('\n').map((err) => (
              <Text my="2" fontSize="sm" color="red.500" m="0">
                {err}
              </Text>
            ))}
          </>
        )}

        <HStack my="6">
          <FormControl isInvalid={errors.name} isRequired>
            <FormLabel mb="0.5" fontSize="sm">First name</FormLabel>
            <Input size="sm" type="text" placeholder="First name" {...register('name', { required: true })} />
            <FormErrorMessage>First name is required</FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.familyName} isRequired>
            <FormLabel mb="0.5" fontSize="sm">Last name</FormLabel>
            <Input size="sm" type="text" placeholder="Last name" {...register('familyName', { required: true })} />
            <FormErrorMessage>Last name is required</FormErrorMessage>
          </FormControl>
        </HStack>

        <FormControl my="6" isInvalid={errors.email} isRequired>
          <FormLabel mb="0.5" fontSize="sm">Email</FormLabel>
          <Input
            size="sm"
            type="email"
            placeholder="Email"
            {...register('email', {
              required: true,
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              },
            })}
          />
          <FormErrorMessage>This is not a valid email address</FormErrorMessage>
        </FormControl>

        <FormControl my="6" isInvalid={errors.password} isRequired>
          <FormLabel mb="0.5" fontSize="sm">Password</FormLabel>
          <Input size="sm" type="password" placeholder="Password" {...register('password', { required: true })} />
          <FormErrorMessage>The password is required</FormErrorMessage>
        </FormControl>

        <PasswordPolicy control={control} register={register} setValue={setValue} policy={passwordPolicy} />

        <input type="hidden" className="form-control" name="asd" />
        <Button colorScheme="blue" type="submit" size="sm" isLoading={isSubmitting} px="10" isDisabled={!isValid}>Sign up</Button>
      </form>
      <Box>
        <Divider my="4" />
        <Text>
          Already have an account?
          <Link as={RLink} to={`/login${removeErrorParam(window.location.search)}`} ml="2" color="blue.600">Sign in</Link>
        </Text>
      </Box>
    </Container>
  );
};

export default SignupPage;
